import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Mail, CheckCircle2 } from "lucide-react";
import { formatApiError } from "../contexts/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_opport-biz-ma/artifacts/oknd9jsa_Logo%20Club%20Business%20Maroc%20Annuaire.png";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "linear-gradient(135deg, #081026 0%, #0D1B3E 50%, #081530 100%)" }}>
      <div className="absolute inset-0 pointer-events-none opacity-5" style={{ backgroundImage: "radial-gradient(circle, #C9A227 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
      <div className="relative z-10 w-full max-w-sm mx-4 animate-fade-in-up">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="Club Business Maroc" className="w-24 h-24 object-contain rounded-xl mb-2" />
        </div>
        <div className="cbm-glass rounded-2xl p-8 shadow-card">
          {sent ? (
            <div className="text-center">
              <CheckCircle2 size={40} className="text-gold mx-auto mb-3" />
              <h2 className="font-outfit font-semibold text-white text-xl mb-2">Email envoyé</h2>
              <p className="text-cbm-secondary text-sm mb-5">Si cet email est enregistré, vous recevrez un lien de réinitialisation dans quelques minutes.</p>
              <Link to="/login" className="cbm-btn-primary text-sm">Retour à la connexion</Link>
            </div>
          ) : (
            <>
              <Link to="/login" className="cbm-btn-ghost text-sm mb-5 inline-flex"><ArrowLeft size={15} /> Retour</Link>
              <h1 className="font-outfit text-2xl font-semibold text-white mb-1">Mot de passe oublié</h1>
              <p className="text-cbm-muted text-sm mb-6">Entrez votre email pour recevoir un lien de réinitialisation.</p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="cbm-label block mb-1.5">Email</label>
                  <div className="relative">
                    <Mail size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-cbm-muted" />
                    <input data-testid="forgot-email" type="email" className="cbm-input pl-9" placeholder="votre@email.com" value={email} onChange={e => setEmail(e.target.value)} required />
                  </div>
                </div>
                {error && <div className="bg-red-900/20 border border-red-800/30 text-red-400 rounded-lg px-4 py-2.5 text-sm">{error}</div>}
                <button data-testid="forgot-submit" type="submit" disabled={submitting} className="cbm-btn-primary w-full justify-center text-sm py-2.5">
                  {submitting ? <><span className="w-4 h-4 border-2 border-navy border-t-transparent rounded-full animate-spin" />Envoi...</> : "Envoyer le lien"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
